// src/config/fileSorts.js
/**
 * Result ordering, as the user picks it.
 *
 * The ids mirror the keys the search endpoint accepts (see the backend's
 * algoliaSortService): each one resolves server-side to a replica index, and
 * the browser never names an index itself. Keep the two lists in step — an id
 * this file invents would come back as a 400.
 */
export const SORTS = [
    {
        id: 'relevance',
        label: 'Best match',
        description: 'How well a file matches your search',
    },
    {
        id: 'newest',
        label: 'Newest first',
        description: 'When the file was added',
    },
    {
        id: 'name',
        label: 'Name (A–Z)',
    },
    {
        id: 'size',
        label: 'Largest first',
    },
];

export const DEFAULT_SORT = 'relevance';

export const isSort = (id) => SORTS.some((s) => s.id === id);

export const sortLabel = (id) => SORTS.find((s) => s.id === id)?.label ?? SORTS[0].label;
